import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import {
  FaPhone, FaEnvelope, FaMapMarkerAlt,
  FaLinkedinIn, FaFacebookF, FaInstagram, FaYoutube,
  FaTwitter, FaArrowRight, FaCode, FaRocket
} from 'react-icons/fa';
import './Footer.css';

const FOOTER_LINKS = {
  company: [
    { label: 'About Us', to: '/about' },
    { label: 'Portfolio', to: '/portfolio' },
    { label: 'Our Products', to: '/products' },
    { label: 'Careers', to: '/careers' },
    { label: 'Contact Us', to: '/contact' },
  ],
  solutions: [
    { label: 'Custom Software', to: '/solutions' },
    { label: 'Mobile Development', to: '/solutions' },
    { label: 'Cloud & DevOps', to: '/solutions' },
    { label: 'AI & ML Solutions', to: '/solutions' },
  ],
  divisions: [
    { label: 'TalentX — Training', to: '/talentx' },
    { label: 'PromoX — Marketing', to: '/promox' },
    { label: 'TalentForce — Staffing', to: '/talentforce' },
  ],
  products: [
    { label: 'SIKGEN AI', to: '/products' },
    { label: 'Vkomak ERP', to: '/products' },
    { label: 'LearnX LMS', to: '/products' },
    { label: 'TalentCRM', to: '/products' },
  ],
};

const SOCIALS = [
  { icon: <FaLinkedinIn />, href: 'https://linkedin.com', label: 'LinkedIn' },
  { icon: <FaFacebookF />, href: 'https://facebook.com', label: 'Facebook' },
  { icon: <FaInstagram />, href: 'https://instagram.com', label: 'Instagram' },
  { icon: <FaYoutube />, href: 'https://youtube.com', label: 'YouTube' },
  { icon: <FaTwitter />, href: 'https://twitter.com', label: 'Twitter' },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-gradient-bar" />

      <div className="footer-body">
        <Container>
          <Row className="g-5">
            {/* Brand Column */}
            <Col lg={4} md={12}>
              <div className="footer-brand">
                <Link to="/" className="footer-logo">
                  <div className="footer-logo-icon"><FaCode /></div>
                  <div>
                    <div className="footer-logo-name">VKOMAK</div>
                    <div className="footer-logo-tagline">Technologies</div>
                  </div>
                </Link>
                <p className="footer-about">
                  Transforming enterprises with cutting-edge SaaS, AI-powered software, and end-to-end digital solutions. Innovation, reliability, and growth — delivered.
                </p>
                {/* Contact mini-block */}
                <div className="footer-contact-list">
                  <a href="tel:+914440066713" className="footer-contact-item">
                    <FaPhone className="fci-icon" />
                    <span>+91 44 - 40066713</span>
                  </a>
                  <a href="mailto:contactus@vkomaktechnologies.com" className="footer-contact-item">
                    <FaEnvelope className="fci-icon" />
                    <span>contactus@vkomaktechnologies.com</span>
                  </a>
                  <div className="footer-contact-item">
                    <FaMapMarkerAlt className="fci-icon" />
                    <span>Chennai – Saidapet, Tamil Nadu, India</span>
                  </div>
                </div>
                {/* Social */}
                <div className="footer-socials">
                  {SOCIALS.map((s, i) => (
                    <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label={s.label}>
                      {s.icon}
                    </a>
                  ))}
                </div>
              </div>
            </Col>

            {/* Links Columns */}
            <Col lg={2} md={6} sm={6}>
              <div className="footer-col">
                <h5 className="footer-col-title">Company</h5>
                <ul className="footer-links">
                  {FOOTER_LINKS.company.map((l, i) => (
                    <li key={i}><Link to={l.to}><FaArrowRight className="flk-arrow" />{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={2} md={6} sm={6}>
              <div className="footer-col">
                <h5 className="footer-col-title">Solutions</h5>
                <ul className="footer-links">
                  {FOOTER_LINKS.solutions.map((l, i) => (
                    <li key={i}><Link to={l.to}><FaArrowRight className="flk-arrow" />{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={2} md={6} sm={6}>
              <div className="footer-col">
                <h5 className="footer-col-title">Divisions</h5>
                <ul className="footer-links">
                  {FOOTER_LINKS.divisions.map((l, i) => (
                    <li key={i}><Link to={l.to}><FaArrowRight className="flk-arrow" />{l.label}</Link></li>
                  ))}
                </ul>
                <h5 className="footer-col-title" style={{ marginTop: '1.75rem' }}>Products</h5>
                <ul className="footer-links">
                  {FOOTER_LINKS.products.map((l, i) => (
                    <li key={i}><Link to={l.to}><FaArrowRight className="flk-arrow" />{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* Newsletter */}
            <Col lg={2} md={6} sm={6}>
              <div className="footer-col">
                <h5 className="footer-col-title">Stay Updated</h5>
                <p className="footer-newsletter-text">Subscribe for the latest tech insights and company news.</p>
                <form className="footer-newsletter-form" onSubmit={e => e.preventDefault()}>
                  <input type="email" placeholder="Your email address" className="footer-input" required />
                  <button type="submit" className="footer-subscribe-btn">
                    <FaRocket /> Subscribe
                  </button>
                </form>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <Container>
          <div className="footer-bottom-inner">
            <span className="footer-copyright">
              &copy; {year} Vkomak Technologies. All rights reserved.
            </span>
            <div className="footer-bottom-links">
              <Link to="/about">Privacy Policy</Link>
              <Link to="/about">Terms of Service</Link>
              <Link to="/about">Cookie Policy</Link>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
